<template>
  <div>
    <plans-table />
  </div>
</template>

<script>
import PlansTable from "../components/plansTable.vue";
export default {
  components: {
    "plans-table": PlansTable
  }
};
</script>

<style></style>
